export const isMobileDevice = () => {
    if (typeof window === "undefined") return false

    // User agent string used to detect common mobile browsers.
    const userAgent = navigator.userAgent || ""
    // Matches phones and mobile browsers, including legacy/edge mobile tokens.
    const isMobileUserAgent =
        /Mobi|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
            userAgent
        )

    return isMobileUserAgent
}